module.exports = __webpack_public_path__ + "img/cns_pc12.b87292ab.png";